import React from 'react';
import { LoginForm } from '@/components/admin/LoginForm';

export const AdminLogin: React.FC = () => {
  return <LoginForm />;
};
